<template>
  <div class="forbidden">
    <p class="forbidden-p">{{ $t("youdonothaveaccess") }}</p>
    <button @click="goToCabinet" class="forbidden-b">
      {{ $t("backToHome") }}
    </button>
  </div>
</template>

<script>
import { CABINET_URL } from "@/config";
export default {
  data() {
    return {
      cabinetUrl: CABINET_URL,
    };
  },
  methods: {
    goToCabinet() {
      window.location.href = this.cabinetUrl;
    },
  },
};
</script>
<style>
.forbidden {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background: url("../../assets/img/background1.png") no-repeat 50% fixed;
  background-size: cover;
  margin-top: 56px;
}
.forbidden-p {
  font-size: 32px;
  color: #fff;
  font-weight: bold;
}
.forbidden-b {
  margin-top: 25px;
  padding: 10px 25px;
  background-color: #0096b2;
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
@media (max-width: 600px) {
  .forbidden-b {
    font-size: 13px;
    padding: 10px 16px;
  }
  .forbidden-p {
    padding: 0 10px;
    font-size: 18px;
    text-align: center;
  }
}
</style>
